import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { AuthProvider } from "./contexts/AuthContext";
import { BookingsProvider } from "./contexts/BookingsContext";
import { Layout } from "./components/layout/Layout";
import { Home } from "./pages/Home";
import { Booking } from "./pages/Booking";
import { Login } from "./pages/Login";
import { Account } from "./pages/Account";
import { ComingSoon } from "./pages/ComingSoon";
import { pendingPages } from "./data/navigation";
export function App() {
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="31agmqk5ke7hc">
      <BrowserRouter data-id="element-1" data-mp="31bibtsjf0ui2">
        <AuthProvider data-id="element-2" data-mp="31c1igd3m7wgs">
          <BookingsProvider data-id="element-3" data-mp="2wk0a329kipw1">
            <Routes data-id="element-4" data-mp="2wjqhd6x524mn">
              <Route element={<Layout data-id="element-6" data-mp="2wip5x1c7ng4e" />} data-id="element-5" data-mp="2wj8e3qc26q58">
                <Route index element={<Home data-id="element-8" data-mp="28tw5osok2m3z" />} data-id="element-7" data-mp="28ufpkexrnkkn" />
                <Route path="reservation" element={<Booking data-id="element-10" data-mp="28sbar1ybx15l" />} data-id="element-9" data-mp="28t4mkhc5agul" />
                <Route path="connexion" element={<Login data-id="element-12" data-mp="23ujkecdc1n3i" />} data-id="element-11" data-mp="23vkzqt1dsvr1" />
                <Route path="mon-espace" element={<Account data-id="element-14" data-mp="3ik7eyd5x05p2" />} data-id="element-13" data-mp="23t8hsfvmildz" />
                {pendingPages.map(page => <Route key={page.path} path={page.path} element={<ComingSoon title={page.title} description={page.description} data-id="element-16" data-mp="3rc9d24sih9w6" />} data-id="element-15" data-mp="3ii4r9zs8ioni" />)}
                <Route path="*" element={<ComingSoon eyebrow="Erreur 404" title="Page introuvable" description="Cette page n'existe pas ou a été déplacée lors de la refonte du site." data-id="element-18" data-mp="2zl3dbpgpde7f" />} data-id="element-17" data-mp="6hpnd64cbd2" />
              </Route>
            </Routes>
          </BookingsProvider>
        </AuthProvider>
      </BrowserRouter>
    </MotionConfig>;
}